/**
 * The scheduler runs both as a standalone web page and inside the Ontiloo POS
 * app, which loads it in a react-native-webview. That webview is the only host
 * that injects the `ReactNativeWebView` bridge, so its presence identifies the
 * POS app. The app owns the station there (it injects `deviceCode` before the
 * page loads), so station-changing UI must stay read-only in that host.
 */
export const isPosApp = (): boolean => {
  if (typeof window === 'undefined') return false;
  // @ts-ignore - injected by react-native-webview, not part of the DOM lib types
  return !!window.ReactNativeWebView;
};

export default isPosApp;
